<template>
  <div class="user-level-management" :class="{ 'is-embedded': embedded }">
    <el-card v-if="!embedded" shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>用户等级管理</span>
          <div class="right-actions">
            <el-input
              v-model="searchKeyword"
              placeholder="按手机号/昵称搜索"
              clearable
              size="small"
              style="width: 220px; margin-right: 10px;"
            />
          </div>
        </div>
      </template>

      <el-table
        :data="filteredUsers"
        style="width: 100%"
        border
        header-align="center"
        align="center"
      >
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="user_id" label="用户ID" min-width="220" />
        <el-table-column prop="nickname" label="昵称" min-width="140" />
        <el-table-column prop="phone" label="手机号" min-width="160" />
        <el-table-column prop="level_name" label="当前等级" min-width="120" />
        <el-table-column prop="benefits_text" label="等级权益" min-width="240" />
        <el-table-column prop="total_points" label="积分总数" min-width="110" />
        <el-table-column prop="used_points" label="已用积分" min-width="110" />
        <el-table-column prop="total_spent_amount" label="累计消费" min-width="140" />
        <el-table-column prop="current_month_spent" label="当月消费" min-width="140" />
        <el-table-column label="无消费降级时间" min-width="180">
          <template slot-scope="scope">
            {{ formatBeijingDateTime(scope.row.level_expire_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary" @click="openAdjustDialog(scope.row)">
              调整
            </el-button>
            <el-button
              v-if="canDeleteUserLevel"
              size="small"
              class="btn-secondary danger"
              @click="openDeleteDialog(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!filteredUsers.length" style="padding: 16px; color: #909399;">
        当前没有匹配数据
      </div>
    </el-card>

    <template v-else>
      <div class="embedded-toolbar card-header">
        <span class="embedded-title">用户等级管理</span>
        <div class="right-actions">
          <el-input
            v-model="searchKeyword"
            placeholder="按手机号/昵称搜索"
            clearable
            size="small"
            style="width: 220px;"
          />
        </div>
      </div>
      <el-table
        :data="filteredUsers"
        style="width: 100%"
        border
        header-align="center"
        align="center"
      >
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="user_id" label="用户ID" min-width="220" />
        <el-table-column prop="nickname" label="昵称" min-width="140" />
        <el-table-column prop="phone" label="手机号" min-width="160" />
        <el-table-column prop="level_name" label="当前等级" min-width="120" />
        <el-table-column prop="benefits_text" label="等级权益" min-width="240" />
        <el-table-column prop="total_points" label="积分总数" min-width="110" />
        <el-table-column prop="used_points" label="已用积分" min-width="110" />
        <el-table-column prop="total_spent_amount" label="累计消费" min-width="140" />
        <el-table-column prop="current_month_spent" label="当月消费" min-width="140" />
        <el-table-column label="无消费降级时间" min-width="180">
          <template slot-scope="scope">
            {{ formatBeijingDateTime(scope.row.level_expire_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary" @click="openAdjustDialog(scope.row)">
              调整
            </el-button>
            <el-button
              v-if="canDeleteUserLevel"
              size="small"
              class="btn-secondary danger"
              @click="openDeleteDialog(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!filteredUsers.length" style="padding: 16px; color: #909399;">
        当前没有匹配数据
      </div>
    </template>

    <!-- 调整对话框 -->
    <el-dialog title="手动调整用户等级/积分" :visible.sync="adjustDialogVisible" width="560px">
      <el-form :model="adjustForm" label-width="120px">
        <el-form-item label="用户ID">
          <el-input v-model="adjustForm.user_id" disabled />
        </el-form-item>
        <el-form-item label="等级编码">
          <el-input v-model="adjustForm.level_code" placeholder="例如：S2" />
        </el-form-item>
        <el-form-item label="积分总数">
          <el-input v-model="adjustForm.total_points" type="number" />
        </el-form-item>
        <el-form-item label="已用积分">
          <el-input v-model="adjustForm.used_points" type="number" />
        </el-form-item>
        <el-form-item label="累计消费金额">
          <el-input v-model="adjustForm.total_spent_amount" type="number" />
        </el-form-item>
        <el-form-item label="当月消费金额">
          <el-input v-model="adjustForm.current_month_spent" type="number" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adjustDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdjust">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="删除用户等级数据"
      :visible.sync="deleteDialogVisible"
      width="480px"
      @closed="resetDeleteForm"
    >
      <p class="delete-hint">
        将删除用户 <strong>{{ deleteTarget && deleteTarget.nickname }}</strong>（{{ deleteTarget && deleteTarget.user_id }}）的等级与积分记录，操作不可恢复。
      </p>
      <el-form label-width="100px">
        <el-form-item label="登录密码">
          <el-input
            v-model="deletePassword"
            type="password"
            show-password
            autocomplete="off"
            placeholder="请输入当前登录账号密码"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="deleteSubmitting" @click="submitDelete">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '../utils/auth'
import { formatBeijingDateTime } from '../utils/dateTimeUtils'

export default {
  name: 'UserLevelManagement',
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    customerUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchKeyword: '',
      users: [],
      adjustDialogVisible: false,
      adjustForm: {
        user_id: '',
        level_code: '',
        total_points: 0,
        used_points: 0,
        total_spent_amount: 0,
        current_month_spent: 0
      },
      deleteDialogVisible: false,
      deletePassword: '',
      deleteTarget: null,
      deleteSubmitting: false
    }
  },
  computed: {
    canDeleteUserLevel() {
      const u = getUserInfo()
      if (!u) return false
      if (u.role === 'admin' || u.roleLabel === '管理员') return true
      return Array.isArray(u.permissions) && u.permissions.includes('客户管理')
    },
    filteredUsers() {
      const kw = (this.searchKeyword || '').trim()
      if (!kw) return this.users
      return this.users.filter(u => (u.nickname && u.nickname.includes(kw)) || (u.phone && u.phone.includes(kw)))
    }
  },
  watch: {
    customerUsers: {
      handler() {
        this.mergeWithCustomerUsers()
      },
      deep: true
    }
  },
  mounted() {
    this.loadUsers()
  }
  ,
  methods: {
    formatBeijingDateTime,
    async loadUsers() {
      try {
        const resp = await this.$api.get('/admin/user-level-list')
        if (resp && resp.code === 200) {
          this.users = resp.data || []
          this.mergeWithCustomerUsers()
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          '获取用户等级列表失败'
        this.$message.error(msg)
      }
    },
    mergeWithCustomerUsers() {
      const levelRows = Array.isArray(this.users) ? this.users : []
      const customerRows = Array.isArray(this.customerUsers) ? this.customerUsers : []
      if (!customerRows.length) return

      const byUserId = new Map()
      levelRows.forEach((r) => {
        const key = String((r && r.user_id) || '').trim()
        if (key) byUserId.set(key, r)
      })

      const merged = [...levelRows]
      customerRows.forEach((cu) => {
        const uid = String((cu && cu.id) || '').trim()
        if (!uid || byUserId.has(uid)) return
        merged.push({
          user_id: uid,
          nickname: cu.username || '',
          phone: cu.phone || '',
          level_name: '未分级',
          benefits_text: '',
          total_points: 0,
          used_points: 0,
          total_spent_amount: 0,
          current_month_spent: 0,
          level_expire_at: ''
        })
      })
      this.users = merged
    },
    openAdjustDialog(row) {
      this.adjustForm = {
        user_id: row.user_id,
        level_code: row.level_code,
        total_points: row.total_points,
        used_points: row.used_points,
        total_spent_amount: row.total_spent_amount,
        current_month_spent: row.current_month_spent
      }
      this.adjustDialogVisible = true
    },
    async submitAdjust() {
      try {
        const payload = { ...this.adjustForm }
        const resp = await this.$api.post('/admin/update-user-level', payload)
        if (resp && resp.code === 200) {
          this.$message.success('调整成功')
          this.adjustDialogVisible = false
          await this.loadUsers()
        } else {
          this.$message.error('调整失败')
        }
      } catch (e) {
        this.$message.error('调整失败')
      }
    },
    openDeleteDialog(row) {
      this.deleteTarget = row
      this.deletePassword = ''
      this.deleteDialogVisible = true
    },
    resetDeleteForm() {
      this.deletePassword = ''
      this.deleteTarget = null
    },
    async submitDelete() {
      if (!this.deleteTarget) return
      const pwd = String(this.deletePassword || '').trim()
      if (!pwd) {
        this.$message.warning('请输入登录密码')
        return
      }
      this.deleteSubmitting = true
      try {
        const resp = await this.$api.post('/admin/delete-user-level', {
          user_id: this.deleteTarget.user_id,
          password: pwd
        })
        if (resp && resp.code === 200) {
          this.$message.success(resp.message || '删除成功')
          this.deleteDialogVisible = false
          await this.loadUsers()
        } else {
          this.$message.error((resp && resp.message) || '删除失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e.message) ||
          '删除失败'
        this.$message.error(msg)
      } finally {
        this.deleteSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-actions {
  display: flex;
  gap: 10px;
}

.user-level-management.is-embedded {
  padding: 0;
}

.embedded-toolbar {
  margin-bottom: 12px;
}

.embedded-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.delete-hint {
  margin: 0 0 16px;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}
</style>

